import { ThunkDispatch } from 'redux-thunk'
import { Action } from 'redux'
import { TYPES as T } from 'action-types/exception-management'
import { TYPES } from 'action-types/filters'
import { applyFilters, applyUsableFilters, formatDate, generateErrors, isFeatureEnabled, transformDocumentNumberFilter } from 'utilities/util'
import { IStore } from 'reducers/index'
import { callApiV3Get, callApiV3Put, callApiV3Post, callApiV2Post } from 'utilities/apiCaller'
import API from 'constants/api'
import { TransportMode } from 'constants/modes'
import { FEATURE_TOGGLES } from 'constants/featureToggles'
export const resetExceptionLogs = () => {
    return async (
        dispatch: ThunkDispatch<any, any, Action>,
        getState: () => IStore
    ) => {
        dispatch({ type: T.FETCH_EXCEPTIONS.PENDING })
    }
}
export const resetLogs = () => {
    return async (
        dispatch: ThunkDispatch<any, any, Action>,
        getState: () => IStore
    ) => {
        dispatch({ type: T.FETCH_LOGS.PENDING })
    }
}
export const fetchExceptions = (pageNumber?: number, pageSize?: number) => {
    return async (
        dispatch: ThunkDispatch<any, any, Action>,
        getState: () => IStore
    ) => {
        dispatch({ type: T.FETCH_EXCEPTIONS.PENDING })
        try {
            const payload = applyFilters(
                getState,
                {
                    isAirInFilters: false,
                    isAirInBody: false,
                },
                {
                    Page: pageNumber,
                    PageNumber: pageNumber,
                    PageSize: pageSize,
                }
            );

            // Transform documentNumber to documentNumbers array
            transformDocumentNumberFilter(payload);

            const res = await callApiV3Post(
                API.EXCEPTION.GetData,
                payload,
                {
                    headers: {
                        TransportMode:
                            TransportMode.Ocean,
                    },
                }
            )
            dispatch({
                type: TYPES.SET_TOTAL_COUNT,
                totalCount: res.data.totalCount,
            })
            dispatch({
                type: T.FETCH_EXCEPTIONS.FULFILLED,
                exceptions: res.data,
            })
        } catch (e) {
            const errors = generateErrors(e)
            dispatch({ type: T.FETCH_EXCEPTIONS.REJECTED, errors })
        }
    }
}
const setDefaultFilters = (state: any): any => {
    if (state && state().filters && state().filters.filters) {
        const filters = state().filters.filters

        const now = new Date();

        now.setDate(now.getDate() - 2);

        filters.documentType = !filters.documentType
            ? 'booking'
            : filters.documentType
        filters.errorEntries = !filters.errorEntries
            ? false
            : filters.errorEntries === 'true'
        filters.dateFrom = !filters.dateFrom
            ? formatDate(now, 'YYYY-MM-DD')
            : filters.dateFrom
    }
    return state
}
export const fetchLogs = (pageNumber?: number, pageSize?: number) => {
    return async (
        dispatch: ThunkDispatch<any, any, Action>,
        getState: () => IStore
    ) => {
        dispatch({ type: T.FETCH_LOGS.PENDING })
        try {
            const checkFilter = setDefaultFilters(getState)
            const isInterfaceLogsWebApiEnabled = isFeatureEnabled(FEATURE_TOGGLES.FINOPS_WEBAPI_INTERFACE_LOGS, getState().featureToggle.featureToggles)
            const logsPayload = isInterfaceLogsWebApiEnabled
                ? applyUsableFilters(
                    checkFilter,
                    {
                        Page: pageNumber,
                        PageSize: pageSize,
                    }
                )
                : applyFilters(
                    checkFilter,
                    {
                        isAirInFilters: false,
                        isAirInBody: false,
                    },
                    {
                        Page: pageNumber,
                        PageNumber: pageNumber,
                        PageSize: pageSize,
                    }
                )
            transformDocumentNumberFilter(logsPayload)
            const res = isInterfaceLogsWebApiEnabled
                ? await callApiV2Post(
                    API.EXCEPTION.InterfaceLogSearch,
                    logsPayload,
                    {}
                )
                : await callApiV3Post(
                    API.EXCEPTION.GetLogs,
                    logsPayload,
                    {
                        headers: {
                            TransportMode:
                                TransportMode.Ocean,
                        },
                    }
                )
            dispatch({
                type: TYPES.SET_TOTAL_COUNT,
                totalCount: res.data.totalCount,
            })
            dispatch({
                type: T.FETCH_LOGS.FULFILLED,
                logs: res.data,
            })
        } catch (e) {
            const errors = generateErrors(e)
            dispatch({ type: T.FETCH_LOGS.REJECTED, errors })
        }
    }
}

export const fetchReprocesseLogs = (pageNumber?: number, pageSize?: number) => {
    return async (
        dispatch: ThunkDispatch<any, any, Action>,
        getState: () => IStore
    ) => {
        dispatch({ type: T.FETCH_REPROCESS.PENDING })
        try {
            const checkFilter = (useDocumentTypeProperty: boolean) => {
                const defaultTypeFilter = 'booking'
                const filters = getState().filters.filters
                if (useDocumentTypeProperty) {
                    const docType = Array.isArray(filters.DocumentType)
                        ? filters.DocumentType[0]
                        : filters.DocumentType
                    filters.DocumentType = !docType ? defaultTypeFilter : docType
                } else {
                    filters.ItemType = !filters.ItemType
                        ? defaultTypeFilter
                        : filters.ItemType
                }
                return getState
            }
            const isReprocessWebApiEnabled = isFeatureEnabled(FEATURE_TOGGLES.FINOPS_WEBAPI_REPROCESS_LOGS, getState().featureToggle.featureToggles)
            const reprocessPayload = isReprocessWebApiEnabled
                ? applyUsableFilters(
                    checkFilter(isReprocessWebApiEnabled),
                    {
                        Page: pageNumber,
                        PageSize: pageSize,
                    }
                )
                : applyFilters(
                    checkFilter(false),
                    {
                        isAirInFilters: false,
                        isAirInBody: false,
                    },
                    {
                        Page: pageNumber,
                        PageNumber: pageNumber,
                        PageSize: pageSize,
                    }
                )
            transformDocumentNumberFilter(reprocessPayload)
            const res = isReprocessWebApiEnabled
                ? await callApiV2Post(
                    API.EXCEPTION.ReprocessLogSearch,
                    reprocessPayload,
                    {}
                )
                : await callApiV3Post(
                    API.EXCEPTION.GetReprocessLogs,
                    reprocessPayload,
                    {
                        headers: {
                            TransportMode:
                                TransportMode.Ocean,
                        },
                    }
                )
            dispatch({
                type: TYPES.SET_TOTAL_COUNT,
                totalCount: res.data.totalCount,
            })
            dispatch({
                type: T.FETCH_REPROCESS.FULFILLED,
                reprocessLogs: res.data,
            })
        } catch (e) {
            const errors = generateErrors(e)
            dispatch({ type: T.FETCH_REPROCESS.REJECTED, errors })
        }
    }
}
export const updateNotification = (id: any, status: string) => {
    return async (
        dispatch: ThunkDispatch<any, any, Action>,
        getState: () => IStore
    ) => {
        dispatch({ type: T.UPDATE_NOTIFICATIONS.PENDING })
        try {
            const res = await callApiV3Post(
                API.EXCEPTION.SetUpdate,
                {
                    NotificationId: id,
                    Status: status,
                },
                {
                    headers: {
                        TransportMode:
                            TransportMode.Ocean,
                    },
                }
            )
            dispatch({
                type: T.UPDATE_NOTIFICATIONS.FULFILLED,
                update: res.data,
            })
        } catch (e) {
            const errors = generateErrors(e)
            dispatch({
                type: T.UPDATE_NOTIFICATIONS.REJECTED,
                errors,
            })
        }
    }
}
export const sendReprocess = (id: string, userId: any) => {
    return async (dispatch: ThunkDispatch<any, any, Action>) => {
        dispatch({ type: T.REPROCESS.PENDING })
        try {
            const res = await callApiV3Put(
                `${API.EXCEPTION.GetData}/${id}/retrigger`,
                { userId },
                {
                    headers: {
                        TransportMode:
                            TransportMode.Ocean,
                    },
                }
            )
            dispatch({
                type: T.REPROCESS.FULFILLED,
                reprocess: res.data,
            })
        } catch (e) {
            const errors = generateErrors(e)
            dispatch({ type: T.REPROCESS.REJECTED, errors })
        }
    }
}
export const toggleReprocess = (id: string, userId: any) => {
    return async (dispatch: ThunkDispatch<any, any, Action>) => {
        dispatch({ type: T.TOGGLE_REPROCESS.PENDING })
        try {
            const res = await callApiV3Put(
                `${API.EXCEPTION.GetData}/${id}/reset`,
                { userId },
                {
                    headers: {
                        TransportMode:
                            TransportMode.Ocean,
                    },
                }
            )
            dispatch({
                type: T.TOGGLE_REPROCESS.FULFILLED,
                reprocess: res.data,
            })
        } catch (e) {
            const errors = generateErrors(e)
            dispatch({ type: T.TOGGLE_REPROCESS.REJECTED, errors })
        }
    }
}
export const requestFile = (id: string, userId: any) => {
    return async (dispatch: ThunkDispatch<any, any, Action>) => {
        dispatch({ type: T.FILE.PENDING })
        try {
            const res = await callApiV3Get(
                `${API.EXCEPTION.GetData}/${id}/file`,
                { userId },
                {
                    headers: {
                        TransportMode:
                            TransportMode.Ocean,
                    },
                }
            )
            dispatch({ type: T.FILE.FULFILLED, file: res.data })
        } catch (e) {
            const errors = generateErrors(e)
            dispatch({ type: T.FILE.REJECTED, errors })
        }
    }
}
export const fetchNotifications = (pageNumber?: number, pageSize?: number) => {
    return async (
        dispatch: ThunkDispatch<any, any, Action>,
        getState: () => IStore
    ) => {
        dispatch({ type: T.FETCH_NOTIFICATIONS.PENDING })
        try {
            const isNotifWebApiEnabled = isFeatureEnabled(FEATURE_TOGGLES.FINOPS_WEBAPI_NOTIFICATION_LOGS, getState().featureToggle.featureToggles)
            const notifPayload = isNotifWebApiEnabled
                ? applyUsableFilters(
                    getState,
                    {
                        Page: pageNumber,
                        PageSize: pageSize,
                    }
                )
                : applyFilters(
                    getState,
                    {
                        isAirInFilters: false,
                        isAirInBody: false,
                    },
                    {
                        Page: pageNumber,
                        PageNumber: pageNumber,
                        PageSize: pageSize,
                    }
                )
            transformDocumentNumberFilter(notifPayload)
            const res = isNotifWebApiEnabled
                ? await callApiV2Post(API.Notifications.NotificationSearch,
                    notifPayload,
                    {}
                )
                : await callApiV3Post(API.EXCEPTION.GetNotifications,
                    notifPayload,
                    {
                        headers: {
                            TransportMode:
                                TransportMode.Ocean,
                        },
                    }
                )
            dispatch({
                type: TYPES.SET_TOTAL_COUNT,
                totalCount: res.data.totalCount,
            })
            dispatch({
                type: T.FETCH_NOTIFICATIONS.FULFILLED,
                notifications: res.data,
            })
        } catch (e) {
            const errors = generateErrors(e)
            dispatch({
                type: T.RESET_NOTIFICATIONS.REJECTED,
                errors,
            })
        }
    }
}
export const resetNotifications = () => {
    return async (
        dispatch: ThunkDispatch<any, any, Action>,
        getState: () => IStore
    ) => {
        dispatch({ type: T.RESET_NOTIFICATIONS.FULFILLED })
    }
}
export const resetReprocess = () => {
    return async (
        dispatch: ThunkDispatch<any, any, Action>,
        getState: () => IStore
    ) => {
        dispatch({ type: T.RESET_NOTIFICATIONS.FULFILLED })
    }
}
